/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import style from "../../styles/navbar.module.scss";
import logo from "../../assets/images/logo.svg";
import { NavLink, Link } from "react-router-dom";
import { Squash as Hamburger } from "hamburger-react";
import { IoMdClose } from "react-icons/io";

const Navbar = () => {
  const [isOpen, setOpen] = useState(false);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <div className={style.container}>
      <div className={style.navbar}>
        <div className={style.innerContainer}>
          <NavLink to="/">
            <img src={logo} alt="Hopa logo" />
          </NavLink>
          <div className={style.links}>
            <NavLink
              className={({ isActive }) => isActive && style.active}
              to={"/"}
            >
              Home
            </NavLink>
            <NavLink
              className={({ isActive }) => isActive && style.active}
              to={"/about-us"}
            >
              About Us
            </NavLink>
            {/* <NavLink
              className={({ isActive }) => isActive && style.active}
              to={"/contact-us"}
            >
              Contact Us
            </NavLink> */}
          </div>
          <div className={style.hamburgerMenu}>
            <div className={style.burger}>
              <Hamburger toggled={isOpen} toggle={setOpen} size={20} />
            </div>
          </div>
        </div>
      </div>
      {isOpen ? (
        <div
          className={`${style.mobileNavbar}  animate__animated animate__fadeInDown`}
        >
          <button
            className={style.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <IoMdClose size={25} aria-label="Close" />
          </button>

          <NavLink
            to="/"
            className={style.logo}
            onClick={() => {
              setOpen(false);
            }}
          >
            <img src={logo} alt="Hopa logo" />
          </NavLink>
          <div className={style.mobileLinks}>
            <Link
              to={"/"}
              onClick={() => {
                setOpen(false);
              }}
            >
              Home
            </Link>

            <NavLink
              to={"/about-us"}
              onClick={() => {
                setOpen(false);
              }}
            >
              About Us
            </NavLink>

            {/* <NavLink
              to={"/contact-us"}
              onClick={() => {
                setOpen(false);
              }}
            >
              Contact Us
            </NavLink> */}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Navbar;
